import axios from "axios";
import { parseJSON } from "./index";
import { Dialog, Toast } from "vant";
import { getPointUserInfo } from "@/api/pointsMall";
import { getQueryString } from "@/util/index";
import store from "../store";

const Axios = axios.create({
  baseURL: "/",
  timeout: 120000,
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/json;",
    "X-Requested-With": "XMLHttpRequest",
    Tenantcode: getQueryString("tenantCode") || localStorage.getItem("tenantCode"),
  },
});
// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  async (config) => {
    config["headers"]["langCode"] = localStorage.getItem("language");
    config["headers"]["pointShopToken"] = parseJSON(
      localStorage.getItem("pmUserInfo") || "{}"
    ).pointShopToken;
    config["headers"]["Tenantcode"] = getQueryString("tenantCode") || localStorage.getItem("tenantCode");

    return config;
  },
  (error) => {
    return Promise.reject(error.data.error.message);
  }
);
// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  (res) => {
    const data = res.data;
    if (data.retCode !== "200") {
      const msg = data.msg ? data.msg : "请求错误！";
      Toast(msg);
      return Promise.reject(msg);
    } else {
      return data.result || {};
    }
  },
  (error) => {
    // 返回 response 里的错误信息
    let errorInfo = error.data.error ? error.data.error.message : error.data;
    return Promise.reject(errorInfo);
  }
);

export default Axios;



// WEBPACK FOOTER //
// src/util/request.js